import { FormRenderer } from '@data-driven-forms/react-form-renderer';
import { PrizeetMappers } from '../../../schema/custom-form/prizeet-mappers';
import { AttributeSchema, AttributeSchemaData } from '../../../schema/data/attribute.schema';
import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import React from 'react';
import { AttributeForm } from './AttributeForm';
import { IFormProps } from '../../../interface/interface';

export interface AttributeCreateProps extends IFormProps<AttributeSchemaData> {
}

export const CreateAttributeForm = (props: AttributeCreateProps) => {
  const { onSubmit, data, onClose, fullWidth, title, isLoading, openModal, maxWidth, editModal, editData } = props;
  const schema = AttributeSchema({
    ...data,
    ...props,
    editData: editModal ? editData : null
  });

  return (
    <>
      <Dialog
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={openModal || editModal}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          {title}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <FormRenderer
            componentMapper={{ ...PrizeetMappers }}
            schema={schema}
            FormTemplate={(data) => <AttributeForm formFields={data.formFields} onSubmit={props.onSubmit} />}
            subscription={{ values: true }}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};
